module.exports = __webpack_public_path__ + "img/15minutes.2b5a09ff.svg";